import { ConfigurationService, HttpService } from ".";

export abstract class BaseService {
    protected apiUrl:string;
    
    constructor(protected httpService: HttpService,
        configurationService: ConfigurationService) {
          this.apiUrl = configurationService.getApiBaseUrl();
        }
}